import type { ReactNode } from 'react';
import { PERIODS, type PeriodDays } from '../api/tasks';
import { Icon, type IconName } from './Icon';

const integer = new Intl.NumberFormat('ru-RU', { maximumFractionDigits: 0 });
export const formatNumber = (value: number) => integer.format(value);

export function KpiCard({
  label,
  icon,
  value,
  extra,
  tone,
}: {
  label: string;
  icon: IconName;
  value: ReactNode;
  extra?: ReactNode;
  tone?: 'good' | 'bad';
}) {
  return (
    <div className={`kpi-card${tone ? ` ${tone}` : ''}`}>
      <span className="kpi-top">
        <span className="kpi-icon">
          <Icon name={icon} size={14} />
        </span>
        <b>{label}</b>
      </span>
      <strong>
        {value}
        {extra ? <em>{extra}</em> : null}
      </strong>
    </div>
  );
}

export function PeriodPills({
  value,
  onChange,
}: {
  value: PeriodDays;
  onChange: (days: PeriodDays) => void;
}) {
  return (
    <fieldset className="pill-row period-pills">
      <legend className="visually-hidden">Период</legend>
      {PERIODS.map((period) => (
        <button
          key={period.days}
          type="button"
          className="pill-toggle"
          aria-pressed={period.days === value}
          onClick={() => onChange(period.days)}
        >
          {period.label}
        </button>
      ))}
    </fieldset>
  );
}

export const formatDay = (value: string | null) =>
  value ? new Date(value).toLocaleDateString('ru-RU', { timeZone: 'Europe/Moscow' }) : '—';

/** «3 дня», «21 день», «5 дней». */
export function days(count: number) {
  const mod10 = count % 10;
  const mod100 = count % 100;
  const word =
    mod10 === 1 && mod100 !== 11
      ? 'день'
      : mod10 >= 2 && mod10 <= 4 && (mod100 < 12 || mod100 > 14)
        ? 'дня'
        : 'дней';
  return `${formatNumber(count)} ${word}`;
}
